import { AllPolarModule as AllCommunityPolarModule } from 'ag-charts-community';
import type { ModuleDefinition } from 'ag-charts-core';

import { AngleCategoryAxisModule } from '../axes/angle-category/angleCategoryAxisModule';
import { AngleNumberAxisModule } from '../axes/angle-number/angleNumberAxisModule';
import { PolarCrossLinesModule } from '../axes/polar-crosslines/polarCrossLinesModule';
import { RadiusCategoryAxisModule } from '../axes/radius-category/radiusCategoryAxisModule';
import { RadiusNumberAxisModule } from '../axes/radius-number/radiusNumberAxisModule';
import { AnimationModule } from '../features/animation/animationModule';
import { ContextMenuModule } from '../features/context-menu/contextMenuModule';
import { SelectionModule } from '../features/data-selection/dataSelectionModule';
import { DataSourceModule } from '../features/data-source/dataSourceModule';
import { GradientLegendModule } from '../gradient-legend/gradientLegendModule';
import { NightingaleSeriesModule } from '../series/nightingale/nightingaleModule';
import { RadarAreaSeriesModule } from '../series/radar-area/radarAreaModule';
import { RadarLineSeriesModule } from '../series/radar-line/radarLineModule';
import { RadialBarSeriesModule } from '../series/radial-bar/radialBarModule';
import { RadialColumnSeriesModule } from '../series/radial-column/radialColumnModule';

export const AllPolarModule: ModuleDefinition[] = [
    AllCommunityPolarModule,

    AngleNumberAxisModule,
    AngleCategoryAxisModule,
    RadiusNumberAxisModule,
    RadiusCategoryAxisModule,
    PolarCrossLinesModule,

    NightingaleSeriesModule,
    RadarAreaSeriesModule,
    RadarLineSeriesModule,
    RadialBarSeriesModule,
    RadialColumnSeriesModule,

    AnimationModule,
    ContextMenuModule,
    DataSourceModule,
    GradientLegendModule,
    SelectionModule,
].flat();
